import config from '../../../config';

export const sendEmailVerification = (payload) => {
  return $.post(`${config.localeApi}/send_verification_email`, payload);
};

export const verifyEmail = hash => {
  const data = { hash };
  return $.post(`${config.localeApi}/verify_email`, data);
}



// WEBPACK FOOTER //
// ./src/Common/Providers/VerifyEmailApi.js